import React from 'react'
import {Button, Header, List, Modal, Table} from 'semantic-ui-react'
import {useSafeState} from '../../../../hook'
import {RedocUI} from '../../../service/versions/docs'

const ApiOverview = ({navigate}) => {
  const [state, setState] = useSafeState({isFullSpecVisible: false})

  const onShowFullSpec = () => {
    setState({isFullSpecVisible: true})
  }

  const onHideFullSpec = () => {
    setState({isFullSpecVisible: false})
  }

  return (
    <div className='doc-section'>
      <Header as='h2'>API</Header>
      <p>
        There may be cases in your CI/CD or automation pipelines where you want to control the management
        of your Mock and/or Contract definitions programmatically. The API is here for you if so.
      </p>
      <Header as='h4' dividing>Authentication</Header>
      <List relaxed>
        <List.Item>1. Login to service mocks</List.Item>
        <List.Item>2. Click the dropdown menu in the top nav and click on "Your Account"</List.Item>
        <List.Item>3. Click on the "Account" menu item</List.Item>
        <List.Item>4. Click on the "Accounts" sub-menu item</List.Item>
        <List.Item>5. You'll see a list of accounts you belong to along w/ API keys for each</List.Item>
        <List.Item>6. Copy the API Key you wish to use and send it in the <b>x-api-key</b> header of your
          requests</List.Item>
      </List>
      <Button basic onClick={() => navigate('/c/account/accounts')}>View API Key(s)</Button>
      <Header as='h4' dividing>Resources</Header>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Service</Table.Cell>
            <Table.Cell>Add, update, and remove services</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Version</Table.Cell>
            <Table.Cell>Add, update, and remove versions</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Contract</Table.Cell>
            <Table.Cell>Add, update contract</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Environment</Table.Cell>
            <Table.Cell>Add, update, and remove environments</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Resource</Table.Cell>
            <Table.Cell>Add, update, and remove resources</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Response</Table.Cell>
            <Table.Cell>Add, update, and remove responses</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Request Log</Table.Cell>
            <Table.Cell>View logs produced from mock resource requests</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <Header as='h4' dividing>Full API Specification</Header>
      <Button basic onClick={onShowFullSpec}>View</Button>


      <Modal size='fullscreen' open={state.isFullSpecVisible} closeOnDimmerClick={true}
             closeIcon={true} dimmer='inverted' onClose={onHideFullSpec}>
        <Modal.Header>
          Full API Specification
        </Modal.Header>
        <Modal.Content>
          <RedocUI
            contract='https://servicemocks.com/api/services/5d8a1e52c2b9e1503ee8e9dc/versions/5d8a1e52c2b9e1503ee8e9db/contract/raw'/>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onHideFullSpec}>Close</Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

export {ApiOverview}

export default ApiOverview